




import { Component, Prop, Vue } from "vue-property-decorator";
import {
  CONSTANT_FILTERS_START_CHAR,
  ROUTE_QUERY_SEPARATOR
} from "@/data/table";

@Component
export default class QuickFiltersMenu extends Vue {
  @Prop({ required: true })
  private routes!: any[];

  @Prop({ required: true })
  private tableId!: string;

  public get computedRoutes() {
    return this.$_.map(this.routes, r => {
      return this.$_.merge({}, r, {
        isActive: () => this.isActive(r)
      });
    });
  }

  private isActive(route) {
    const path = this.$_.isFunction(route.to) ? route.to(this) : route.to;
    const resolved = this.$router.resolve(path);
    const fields = ["hash", "matched", "meta", "name", "params", "path"];
    const isSameRoute = this.$_.isEqual(
      this.$_.pick(resolved.route, fields),
      this.$_.pick(this.$route, fields)
    );
    const query = this.$_.isString(resolved.route.query)
      ? resolved.route.query
      : this.$_.head(this.$_.toArray(resolved.route.query));
    const filters = this.getConstFilters(
      this.$_.get(this.$route, `query.${this.tableId}`, "")
    );

    const isSameFilters = filters === this.getConstFilters(`${query}`);
    return isSameFilters && isSameRoute;
  }

  private getConstFilters(path: string) {
    return this.$_.sortBy(
      this.$_.map(
        this.$_.filter(
          path.split(ROUTE_QUERY_SEPARATOR),
          filter => filter[0] === CONSTANT_FILTERS_START_CHAR
        ),
        constFilter => constFilter
      )
    ).join(",");
  }
}
